import { useIntl } from "react-intl";

import { Editions, ProductKeys } from "@atlassiansox/asc-stargate";

import { useCrossFlowFrontendTouchpoint } from "@/components/cross-flow/touchpoint/use-touchpoint/index";
import { useLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";
import { LogoV3 } from "@/libraries/wpl/foundations/src/logo-v3";
import { LogoV2 } from "@/libraries/wpl/foundations/src/logov2";
import { ProductPageSubNav } from "@/patterns/global-nav/src/nav-product-page";
import { experiments } from "@/utils/experiment/manifest";
import { useExperiment } from "@/utils/experiment/use-experiment";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

const JpdLogo = () => {
    const gwp7518NavIconUpdates = checkFeatureFlagGate(
        featureFlags.gwp7518NavIconUpdates
    );

    return gwp7518NavIconUpdates ? (
        <LogoV3 brand="jiraproductdiscovery" type="logo" appearance="brand" />
    ) : (
        <LogoV2 brand="jiraproductdiscovery" type="logo" appearance="brand" />
    );
};

const JiraProductDiscoveryNavV2 = () => {
    const intl = useIntl();
    const signupLink = useLocalizedHref(
        "/try/cloud/signup?bundle=jira-product-discovery"
    );
    const { openCrossFlow } = useCrossFlowFrontendTouchpoint({
        productKey: ProductKeys.JIRA_PRODUCT_DISCOVERY,
        edition: Editions.FREE,
        redirectUrl: signupLink
    });
    const links = [
        {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                // this id can be renamed once the above has been fixed as well
                id: "jiraproductdiscovery.navbar.product-features",
                defaultMessage: "Features"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: useLocalizedHref("/software/jira/product-discovery/features")
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                // this id should be renamed, but for Team'24 hotfix we need to keep existing mapping
                id: "jiraproductdiscovery.navbar.features",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: useLocalizedHref("/software/jira/product-discovery/pricing")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "jiraproductdiscovery.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: useLocalizedHref("/software/jira/product-discovery/resources")
        }
    ];

    // TODO: this duplicates the value from the v1 product nav
    // this was to use an accurate existing translation for a Team'24 hot fix
    const productNavGoToAppCta = useExperiment(
        experiments.productNavGoToAppCta
    );
    const isExperimentEnabled =
        productNavGoToAppCta.type === "enrolled" &&
        productNavGoToAppCta.value === true;
    const ctaText = isExperimentEnabled
        ? intl.formatMessage({
              id: "productNavBar.openJPD",
              defaultMessage: "Open App"
          })
        : intl.formatMessage({
              id: "productNavBar.get-it-free-button",
              defaultMessage: "Get it free"
          });

    return (
        <ProductPageSubNav
            productLogoUrl={useLocalizedHref(
                "/software/jira/product-discovery"
            )}
            productLogo={<JpdLogo />}
            productLogoAriaLabel={intl.formatMessage({
                id: "wacJiraProductDiscoveryNavigation.logo-label",
                defaultMessage: "Jira Product Discovery logo"
            })}
            mobileCtaText={ctaText}
            mobileCtaUrl={signupLink}
            mobileCtaOnClick={openCrossFlow}
            mobileLogo={<JpdLogo />}
            navigationTrynowCtaText={ctaText}
            navigationTrynowCtaUrl={signupLink}
            navigationTrynowCtaOnClick={openCrossFlow}
            productPageNavLinks={links}
            mobileLinksSections={[
                {
                    mobileLinkKey: "mobile-jira-product-discovery",
                    mobileLinksProps: links
                }
            ]}
        />
    );
};

JiraProductDiscoveryNavV2.displayName = "JiraProductDiscoveryNavV2";

export default JiraProductDiscoveryNavV2;
